import { CloseOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import React from "react"; 
import { SidebarData } from "../SidebarData";
import Menu_Item from "./Menu_Item";

export const DrawerMenu=({ collapsed, onClose, setcollapsed })=> {
  var _collapsed = collapsed;
  var _SidebarData_=SidebarData;
  var _setcollapsed= setcollapsed;
  return (
    <div>
      <Drawer
        title="Robograf"
        closeIcon={<CloseOutlined />}
        placement="left"
        closable={true}
        onClose={onClose}
        visible={collapsed}
      >
          <Menu_Item setcollapsed={_setcollapsed} collapsed={_collapsed} items={_SidebarData_}/>
      </Drawer>
    </div>
  );
}

export default DrawerMenu;
